import React from 'react';

import ConcertDetails from 'features/tours/ConcertDetails';

const ConcertDetailsPage = () => {
  return (
    <ConcertDetails />
  );
};

export default ConcertDetailsPage;
